import { useEffect } from 'react';
import { successModalState } from '../utils/SuccessModalState';
import { BUSINESS_TRIGGER_CTA, CtaData } from '../types';

export const useSuccessSignCtaEvent = ({
    type = BUSINESS_TRIGGER_CTA.DEFAULT,
    source,
    callback,
}: {
    type: BUSINESS_TRIGGER_CTA;
    source?: string;
    callback(event: CustomEvent<CtaData>): void;
}) => {
    useEffect(() => {
        if (!successModalState.isModalAvailable()) {
            return;
        }

        successModalState.registerCtaEvent({ type, source, callback });

        return () => {
            successModalState.removeCtaEvent({ type, source, callback });
        };
    }, [type, source, callback]);
};
